
<template>
  <v-card>
    <v-card-title class="headline grey lighten-2 d-just-space">
      {{ title }}
      <div class="d-flex mb-3">
        <div
          v-if="HidePrintButton"
          class="downloadsummaryPDF cursor w-2"
          @click="print"
        >
          <printer />
        </div>
        <div
          v-if="HideDownloadButton"
          class="downloadsummaryPDF cursor w-2"
          @click="download"
        >
          <download />
        </div>
        <div class="downloadsummaryPDF cursor w-2" @click="closeModal()">
          <crossSVG />
        </div>
      </div>
    </v-card-title>
    <div>
      <div class="ww-100">
        <div v-if="showPrevToggle" class="pdf-arrow pdf-arrow-left">
          <button class="btn" @click="$emit('togglePdf', -1)">
            <downArrow />
          </button>
        </div>
        <div v-if="showNextToggle" class="pdf-arrow pdf-arrow-right">
          <button class="btn" @click="$emit('togglePdf', 1)">
            <downArrow />
          </button>
        </div>

        <v-card v-if="!hideCard" class="min-height pdf-modal">
          <v-card-text
            :style="[
              !fullHeight ? 'height: 82vh' : '',
              'overflow: hidden; overflow-y: auto'
            ]"
          >
            <div class="pdf-loader">
              <div class="p-0 loader-img-div" v-if="showLoader">
                <p>Loading</p>
              </div>
            </div>
            <div id="pdf-view" v-html="html"></div>
          </v-card-text>
          <v-card-actions class="p-allvw">
            <div class="col-sm-12 d-align p-0">
              <div class="col-sm-7 p-0">
                <p
                  class="mb-0 reference-text text-success"
                  v-if="ReferenceText"
                >
                  This prescription will be saved in Menu > prescription of
                  patient / doctor
                </p>
              </div>
              <div class="col-sm-5 flex-end p-0" v-if="buttons.length">
                <v-btn
                  v-for="(button, bKey) in buttons"
                  class="ml-3"
                  :key="bKey"
                  :class="['btn', button.class]"
                  @click="button.action"
                  >{{ button.text }}</v-btn
                >
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </v-card>
</template>
<script>
import config from "@/config";
import { pickSvg } from "@/views/SVG";
export default {
  data() {
    return {
      html: "",
      showLoader: true
    };
  },
  components: {
    ...pickSvg("printer", "download", "downArrowSVG", "crossSVG")
  },
  props: {
    identifier: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    fullHeight: {},
    reCompile: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default: []
    },
    showPrevToggle: {
      type: Boolean,
      default: false
    },
    showNextToggle: {
      type: Boolean,
      default: false
    },
    hideCard: {
      type: Boolean,
      default: false
    },
    HideDownloadButton: {
      type: Boolean,
      default: false
    },
    HidePrintButton: {
      type: Boolean,
      default: false
    },
    ReferenceText: {
      type: Boolean,
      default: false
    },
    queryParameters: {
      type: String,
      default: ""
    },
    instantDownload: {
      type: Boolean,
      default: false
      
    }
  },
  mounted() {
    this.getPdf();
    if(this.instantDownload)this.download();
  },
  computed: {
    pdfUrl() {
      switch (this.subject) {
        case "shareLink":
          return `${config.BASE_URL}api/v2/pdf/user-profile/${
            this.identifier
          }/qr${this.queryParameters ? "?" + this.queryParameters + "&" : ""}`;
        case "invoiceDr":
          return `${config.BASE_URL}api/v2/pdf/invoice/doctor/${this.identifier}`;
          case "platformInvoice":
          return `${config.BASE_URL}api/v2/pdf/invoice/platform/${this.identifier}`;
        default:
          break;
      }
    }
  },
  watch: {
    identifier: function(val) {
      this.html = "";
      this.showLoader = true;
      this.getPdf();
    }
  },
  methods: {
    getParams() {
      let params = {
        _token: localStorage.getItem("token")
      };
      if (this.reCompile) {
        params.re_compile = true;
      }
      return params;
    },
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    resetHtml() {
      this.html = null;
      this.showLoader = true;
    },
    getPdf() {
      if (!this.identifier) {
        return;
      }
      this.$nextTick(() => {
        this.getPdfHttp().then(response => {
          this.showLoader = false;
          this.html = response.data;
          this.$emit("pdfLoaded");
        });
      });
    },
    getPdfHttp() {
      return this.$http.get(this.pdfUrl, { params: this.getParams() });
    },
    download() {
      this.$nextTick(() => {
        let params = Object.assign({}, this.getParams(), {
          to_download: "true"
        });
        window.open(
          `${this.pdfUrl}${
            this.subject === "shareLink" ? "" : "?"
          }${this.serialize(params)}`
        );
      });
    },
    print() {
      this.$nextTick(() => {
        this.getPdfHttp().then(response => {
          let params = Object.assign({}, this.getParams(), {
            to_stream: "true"
          });
          window.open(
            `${this.pdfUrl}${
              this.subject === "shareLink" ? "" : "?"
            }${this.serialize(params)}`
          );
        });
      });
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>
<style  lang="scss" scoped>
.reference-text {
  font-size: clamp(12px, 0.7vw, 18px);
  font-weight: bold;
}
</style>

